import { FeedbackProps } from './types';

export const FEEDBACK_CATEGORY: Record<string, FeedbackProps['category']> = {
  CONVENIENCE_OF_APPLYING: 1,
  QUALITY_OF_SERVICE: 2,
} as const;
